export enum VERIFICATION_TYPE {
  quantity = "QUANTITY",
  years = "YEARS",
}
